import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Compania } from '../shared/models/compania';
import { Ciudad } from '../shared/models/ciudad';
import { Sede } from '../shared/models/sede';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { CrearVlanParametros } from '../shared/models/crear-vlan-parametros';
import { CompaniaService } from '../shared/services/compania.service';
import { CiudadService } from '../shared/services/ciudad.service';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { SesionService } from '../shared/services/sesion.service';
import { CargandoComponent } from '../cargando/cargando.component';
import { environment } from '../../environments/environment';
import { ErrorDto } from '../shared/models/error-dto';
@Component({
  selector: 'app-crear-vlan-admin',
  templateUrl: './crear-vlan-admin.component.html',
  styleUrls: ['./crear-vlan-admin.component.css']
})
export class CrearVlanAdminComponent implements OnInit {
  principalForm = this.formBuilder.group({
    selectCompania: new FormControl('', Validators.required),
    selectCiudad: new FormControl('', Validators.required),
    selectSede: new FormControl('', Validators.required),
    selectMascara: new FormControl('', Validators.required),
    selectAmbiente: new FormControl('', Validators.required),
    imputIpInicial: ['', Validators.required],
    imputVlan: ['', Validators.required],
    textAreaObeservaciones: new FormControl(),
  });

  codigoListaMascaras = environment.listaCodigoMascara;
  companias: Compania[];
  ciudades: Ciudad[];
  idAmbienteSeleccionado: number;
  sedes: Sede[];
  ambientes: ListaItem[];
  mascaras: ListaItem[];
  idCompaniaSeleccionada: number;
  idCiudadSeleccionada: number;
  idSedeSeleccionada: number;
  idMascaraSeleccionada: number;
  nombreVlan: string;
  ipInicial: string;
  observaciones: string;
  parametros: CrearVlanParametros = new CrearVlanParametros();
  modalRef: NgbModalRef;
  mensajeAlerta: string;
  errorDto: ErrorDto = new ErrorDto();
  permisoCrearvlanSede: boolean;

  constructor(private companiaService: CompaniaService,
    private ciudadService: CiudadService, private sedeService: SedeService,
    private listaItemService: ListaItemService, private vlanService: VlanService,
    private administradorIpService: AdministradorIpService,
    private modalService: NgbModal, private formBuilder: FormBuilder,
    private sesionService: SesionService) { }

  ngOnInit() {
    this.sesionService.permisoCrearVlanSede().subscribe(
      resultado => this.permisoCrearvlanSede = resultado
    );
    this.listarCompanias();
    this.listarMascaras();
  }

  public listarCompanias(): void {
    this.companiaService.listarCompanias().subscribe(
      resultado => this.companias = resultado
    );
  }

  public listarCiudadaesPorCompania(): void {
    this.idCiudadSeleccionada = null;
    this.idSedeSeleccionada = null;
    this.ciudades = null;
    this.sedes = null;
    this.ciudadService.ciudadesPorIdCompania(this.idCompaniaSeleccionada).subscribe(
      resultado => this.ciudades = resultado
    );
  }

  public listarSedesPorCompaniaCiudad(): void {
    this.idSedeSeleccionada = null;
    this.sedes = null;
    this.sedeService.sedesPorCompaniaCiudad(this.idCompaniaSeleccionada, this.idCiudadSeleccionada).subscribe(
      resultado => this.sedes = resultado
    );
  }
  public listarAmbientes(): void {
    this.idAmbienteSeleccionado = null;
    this.listaItemService.ambientesPorCompaniaSedeValidaDMZ(this.idCompaniaSeleccionada,
      this.idSedeSeleccionada).subscribe( 
        resultado => this.ambientes = resultado
      );
  }
  public listarMascaras(): void {
    this.listaItemService.listarMascarasConfiguradas().subscribe(
      resultado => {
        this.mascaras = resultado
        this.mascaras = this.mascaras.filter(item => item.valorItem.includes('255.255.248.0') || item.valorItem.includes('255.255.252.0') || item.valorItem.includes('255.255.254.0') || item.valorItem.includes('255.255.255.0'));

      }
    );
  }

  public guardarVlanSinRango(cargandoModal, alertaModal, resultadoModal): void {
    this.modalRef = this.modalService.open(cargandoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
    this.parametros.compania = new Compania();
    this.parametros.compania.idCompania = this.idCompaniaSeleccionada;
    this.parametros.idCiudad = this.idCiudadSeleccionada;
    this.parametros.idMascara = this.idMascaraSeleccionada;
    this.parametros.idSede = this.idSedeSeleccionada;
    this.parametros.ipInicial = this.ipInicial;
    this.parametros.nombreVlan = this.nombreVlan;
    this.parametros.observaciones = this.observaciones;
    this.parametros.idAmbiente=this.idAmbienteSeleccionado;
    this.administradorIpService.crearVlanSinRango(this.parametros).subscribe(
      respuesta => {
        this.parametros = respuesta;
        this.modalRef.close();
        this.modalRef = this.modalService.open(resultadoModal, { backdrop: 'static', keyboard: false, size: 'lg' });
      }, error => {
        this.modalRef.close();
        this.errorDto = error.error;
        this.mensajeAlerta = this.errorDto.mensajeError;
        this.modalRef = this.modalService.open(alertaModal, { size: 'lg' });
      }
    );
  }

  public ocultarModalResultado() {
    this.idCompaniaSeleccionada = null;
    this.idCiudadSeleccionada = null;
    this.idSedeSeleccionada = null;
    this.idMascaraSeleccionada = null;
    this.ipInicial = null;
    this.nombreVlan = null;
    this.observaciones = null;
    this.modalRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/crear-vlan-admin/crear-vlan-admin.component.ts